import { render, staticRenderFns } from "./SetList.vue?vue&type=template&id=2fa70626&scoped=true"
import script from "./SetList.vue?vue&type=script&lang=js"
export * from "./SetList.vue?vue&type=script&lang=js"
import style0 from "./SetList.vue?vue&type=style&index=0&id=2fa70626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa70626",
  null
  
)

export default component.exports